// extracted by mini-css-extract-plugin
export var grid = "fp-CC";
export var gridWithRowGap = "fp-DC";
export var maxWidthContainer = "fp-HC";
export var modal = "fp-IC";
export var modal__close = "fp-BC";
export var modal__close__icon = "fp-OC";
export var modal__content = "fp-JC";
export var modal__contentAuto = "fp-LC";
export var modal__contentPopup = "fp-MC";
export var modal__contentPortrait = "fp-KC";
export var mt0 = "fp-uC";
export var mt1 = "fp-vC";
export var mt2 = "fp-wC";
export var mt3 = "fp-xC";
export var mt4 = "fp-yC";
export var mt5 = "fp-zC";
export var mt6 = "fp-AC";
export var popupModal = "fp-NC";
export var removeVisuallyHidden = "fp-FC";
export var visuallyHidden = "fp-EC";
export var widgetBase = "fp-GC";